export default __webpack_public_path__ + "static/media/node.500e6add.PNG";